module.exports = __webpack_public_path__ + "img/rings.91762b2a.svg";